import React from 'react';
import { WhySectionListItemCustomisation } from '../../../common/CommonTypes';

export type WhyTabPanel = {
  iconSrc: string;
  iconAlt: string;
  panelTitleText: string;
  panelDetailText: string;
};

type WhyTabItemProps = {
  panel: WhySectionListItemCustomisation;
  index: number;
};

const WhyTabItem = ({ panel, index }: WhyTabItemProps): JSX.Element => {
  const {
    whySectionItemTitle,
    whySectionItemDescription,
    whySectionItemLogoUrl
  } = panel;

  const getAlt = () => {
    return 'icon-' + index;
  };

  return (
    <div className='flex-column why--item'>
      <img className='icon-style' src={whySectionItemLogoUrl} alt={getAlt()} />
      <div className='lp-why-item-header'>{whySectionItemTitle}</div>
      <div>{whySectionItemDescription}</div>
    </div>
  );
};

export default WhyTabItem;
